import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TableFilters } from '../../../../../models/entities/table-filters';
import { FormStatus } from '../../../../../enums/form-status.enum';
import { FormSubmissionStates } from '../../../../app-layout/forms/form-detail/form-submission-table-filters/form-submission-table-filters.component';
import { originalOrderFunction } from '../../../../../functions/original-order';
import { SidenavContentRef } from '../../../shared/sidenav/sidenav-content/sidenav-content-ref';
import { SIDENAV_CONTENT_DATA } from '../../../shared/sidenav/sidenav-content/sidenav-content.service';
import { SidenavContentModule } from '../../../shared/sidenav/sidenav-content/sidenav-content.module';
import { ButtonSpacerDirective } from '../../../shared/directives/button.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { KeyValuePipe, NgForOf } from '@angular/common';
import { CapitalizePipeModule } from '../../../../../pipes/format/capitalize.module';

export interface RequestFormSubmissionFiltersSidenavInput {
    filters: TableFilters;
}

export interface RequestFormSubmissionFiltersSidenavOutput {
    success: true;
    filters: TableFilters;
}

@Component({
    selector: 'app-request-form-submission-filters-sidenav',
    templateUrl: './request-form-submission-filters-sidenav.component.html',
    standalone: true,
    imports: [
        SidenavContentModule,
        ButtonSpacerDirective,
        MatButtonModule,
        MatRadioModule,
        NgForOf,
        CapitalizePipeModule,
        KeyValuePipe,
        ReactiveFormsModule,
    ],
})
export class RequestFormSubmissionFiltersSidenavComponent
{
    formGroup = this._fb.nonNullable.group({
        form: this.data.filters.form,
        state: this.data.filters.state || 'open',
        formState: this.data.filters.formState || 'active',
    });

    readonly formStatuses = FormStatus;
    readonly formSubmissionStates = FormSubmissionStates;
    readonly originalOrder = originalOrderFunction;

    constructor(
            private _fb: FormBuilder,
            private _sidenavRef: SidenavContentRef<RequestFormSubmissionFiltersSidenavComponent>,
            @Inject(SIDENAV_CONTENT_DATA) public data: RequestFormSubmissionFiltersSidenavInput,
    ) {
    }

    applyFilters() {
        const output: RequestFormSubmissionFiltersSidenavOutput = {
            success: true,
            filters: this.formGroup.value,
        };
        this._sidenavRef.close(output);
    }
}
